export default __webpack_public_path__ + "static/Sketch3-59469ab8945b65b570aaa0f1254839d6.jpg";